import { useRef, type MutableRefObject } from 'react';
import { Dialog } from '@headlessui/react';

import { Button } from '../Button';
import { Modal } from '../Modal';

type ConfirmButtonVariant = 'primary' | 'outline';

type Props = {
  textTitle: string;
  textMessage?: string;
  textCancel: string;
  textConfirm: string;
  confirmButtonVariant?: ConfirmButtonVariant;
  confirmButtonClassName?: string;
  onClose: () => void;
  onConfirm: () => void;
  open: boolean;
  isLoading?: boolean;
};

export function ConfirmModal({
  textCancel,
  textConfirm,
  confirmButtonVariant = 'primary',
  confirmButtonClassName,
  textMessage,
  textTitle,
  onClose,
  onConfirm,
  open,
  isLoading = false,
}: Props) {
  const cancelButtonRef = useRef<HTMLButtonElement | null>(null);

  return (
    <Modal
      open={open}
      onClose={onClose}
      initialFocus={cancelButtonRef as MutableRefObject<HTMLElement | null>}
    >
      <div>
        <Dialog.Title
          as="h2"
          className={`text-lg font-bold text-ink ${textMessage ? 'mb-2' : 'mb-6'}`}
        >
          {textTitle}
        </Dialog.Title>
        {textMessage ? (
          <Dialog.Description className="mb-6 whitespace-pre-line text-neutral-600">
            {textMessage}
          </Dialog.Description>
        ) : null}
      </div>
      <div className="flex flex-col gap-3 sm:flex-row sm:gap-4">
        <Button
          type="button"
          ref={cancelButtonRef}
          variant="outline"
          onClick={onClose}
          disabled={isLoading}
          className="flex-1"
        >
          {textCancel}
        </Button>
        <Button
          type="button"
          variant={confirmButtonVariant}
          onClick={onConfirm}
          disabled={isLoading}
          loading={isLoading}
          className={`flex-1 ${confirmButtonClassName ?? ''}`}
        >
          {textConfirm}
        </Button>
      </div>
    </Modal>
  );
}
